import { DateTime } from 'luxon';
import getFiscalEntitiesFromInterval from '../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/FiscalPeriodsProvider/getFiscalEntitiesFromInterval';
import getCurrentFiscalEntity from '../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/FiscalPeriodsProvider/getCurrentFiscalEntity';

const getComparisonPreviousFiscalEntities = (
  startDate: DateTime,
  intervalAmount: number | undefined,
  interval: FixedPeriods.FiscalType,
  currentToDate: boolean,
  fiscalRanges: FixedPeriods.AllFiscals,
) => {
  let entities:
    | FixedPeriods.FiscalPeriod[]
    | FixedPeriods.FiscalQuarter[]
    | FixedPeriods.FiscalYear[]
    | undefined;

  entities = getFiscalEntitiesFromInterval(interval, fiscalRanges);
  if (!entities) {
    throw new Error(`No fiscal entities found for interval ${interval}`);
  }

  const currentRangeIndex = entities.findIndex(
    (e) => e.startDate === startDate.toISODate(),
  );

  if (!intervalAmount) {
    return {
      startDate: DateTime.fromISO(entities[currentRangeIndex - 1]?.startDate),
      endDate: DateTime.fromISO(entities[currentRangeIndex - 1]?.endDate),
    };
  }

  const startRange = entities[currentRangeIndex - intervalAmount];
  const endRange = entities[currentRangeIndex - 1];

  if (!startRange || !endRange) {
    return {
      startDate: undefined,
      endDate: undefined,
    };
  }

  let comparisonEndDate: DateTime | undefined = undefined;
  if (currentToDate) {
    const current = getCurrentFiscalEntity(entities);

    if (!current) {
      throw new Error('No current fiscal entity found');
    }

    const currentStartDate = DateTime.fromISO(current.startDate);
    const diffDays = currentStartDate.diff(
      DateTime.now().minus({ days: 1 }).startOf('day'),
      'days',
    ).days;
    comparisonEndDate = currentStartDate.plus({ days: diffDays });
  } else {
    comparisonEndDate = DateTime.fromISO(endRange?.endDate);
  }
  return {
    startDate: DateTime.fromISO(startRange?.startDate),
    endDate: comparisonEndDate,
  };
};

export default getComparisonPreviousFiscalEntities;
